import React from 'react';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import BoxWrapper from 'components/atoms/BoxWrapper';
import { fonts } from 'theme/Variables';
import CustomTypography from 'components/atoms/CustomTypography';
import HeaderTemplate from 'templates/HeaderTemplate/HeaderTemplate';

const PrivacyPolicy = () => {
    return (
        <>
            <HeaderTemplate title="Privacy Policy" />
            <Container>
                <BoxWrapper mt="50">
                    <Grid container justify="center">
                        <Grid item xs={12} md={6}>
                            <BoxWrapper mb="25" justifyContent="flex-start">
                                <CustomTypography
                                    variant="h3"
                                    fontSize="2.6"
                                    customfont={fonts.secondary}
                                >
                                    Data Privacy Notice
                                </CustomTypography>
                            </BoxWrapper>
                            <BoxWrapper mb="25" justifyContent="flex-start">
                                <CustomTypography>
                                    This document explains how Mobilise uses data. <br />
                                    <br />
                                    Our mission is to help carers access the support they need in
                                    order to continue looking after the person they love as best
                                    they can.
                                    <br />
                                    <br />
                                    In order to do that, we need to know a bit about the carers
                                    we’re talking to - for example, where they live. This helps us
                                    find out what support is available to them in their local area.{' '}
                                    <br />
                                    <br />
                                    <strong>What data do we collect?</strong> <br />
                                    We collect personal identifiable information (Names, e-mail
                                    addresses, post-codes etc) We also collect personal information
                                    about health conditions, and how people are coping with their
                                    caring role - things they’re doing well with, and things they
                                    struggle with.
                                    <br />
                                    <br />
                                    <strong>How do we collect the data?</strong>
                                    <br />
                                    We make sure that anybody using our website is fully aware of
                                    what data they’re sharing with us, and when.
                                    <br />
                                    <br />
                                    Our chat bot assessment asks people a series of questions and
                                    records their responses. Carers only ever share information with
                                    our chat bot voluntarily.
                                    <br />
                                    <br /> ​<strong>How do we use the data?</strong>
                                    <br /> We uses the responses from out chat bot conversations to
                                    put together a suggested action plan for some of the ways in
                                    which a carer can access support that might help them out. We
                                    use the e-mail address we recorded to send it to them.
                                    <br /> <br />
                                    A little while later, we will be in touch again to see how a
                                    carer got on with the action plan, so that we can help future
                                    carers more effectively by learning from their experience.
                                    <br />
                                    <br /> We never share carers’ data with third parties for
                                    marketing purposes.
                                    <br />
                                    <br />
                                    <strong>How do we store your data?</strong>
                                    <br /> We use third party data storage systems which are fully
                                    GDPR compliant.
                                    <br />
                                    <br />
                                    <strong>What are your data protection rights?</strong>
                                    <br /> Every user of our data is entitled to the following:
                                    <br /> <strong>The right to access</strong> - You have the right
                                    to ask Mobilise for copies of your personal data. We may charge
                                    you a small fee for this service.
                                    <br /> <strong>The right to rectification</strong> - You have
                                    the right to ask Mobilise to rectify or complete any information
                                    you believe to be inaccurate or incomplete.
                                    <br /> <strong>The right to erasure</strong> - You have the
                                    right to ask Mobilise to erase your personal data
                                    <br /> <strong>The right to restrict processing</strong> - You
                                    have the right to ask Mobilise to restrict the way we process
                                    your data, or to process your data at all, under certain
                                    conditions.
                                    <br /> <strong>The right to data portability</strong> - You have
                                    the right to ask Mobilise to transfer your personal data to
                                    another organisation, or to yourself, under certain conditions.
                                    <br />
                                    <br /> <strong>How to contact us</strong> If you have any
                                    further questions about how we work with your data, please
                                    contact info@mobiliseonline.co.uk
                                </CustomTypography>
                            </BoxWrapper>
                        </Grid>
                    </Grid>
                </BoxWrapper>
            </Container>
        </>
    );
};

export default PrivacyPolicy;
